import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=a53f5f44&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=a53f5f44&prod&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=a53f5f44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53f5f44",
  null
  
)

export default component.exports